import {Input} from '@angular/core';
import {AfterViewInit, Component, ElementRef, HostListener, NgZone, OnInit, OnDestroy} from '@angular/core';
import {WaveformRenderer} from './waveform-renderer';
import {TimeIndicator} from './waveform-renderer/time-indicator';
import {TimelineService} from "../../timeline.service";
import {Storyboard} from "storyboard-renderer";
import {TimelineTimestamp} from "storyboard-renderer";
import {DragService} from "../../../../shared/drag.service";
import {RequestMethod, ResponseContentType, Http, RequestOptionsArgs, RequestOptions} from "@angular/http";

@Component({
  selector: 'app-waveform',
  template: '',
  styleUrls: ['./waveform.component.scss']
})
export class WaveformComponent implements OnInit {

  @Input() storyboard: Storyboard;

  waveformRenderer: WaveformRenderer;

  constructor(
    private element: ElementRef,
    private zone: NgZone,
    private timelineService: TimelineService,
    private dragService: DragService,
    private http: Http
  ) {
    this.element = element;

    timelineService.zoomChangeEvent
      .debounceTime(200)
      .subscribe((zoom) => {
        this.resizeWaveform();
        const currentPlaybackPosition = this.timelineService.convertTimeToPx(this.timelineService.playerControl.getCurrentTime().as_milliseconds);
        const newOffsetValue = -currentPlaybackPosition + (this.timelineService.getTimelineWidthInPx() / 2);
        this.timelineService.setTimelinePosition(newOffsetValue);
      });
    timelineService.durationChangeEvent.subscribe((duration) => this.resizeWaveform());
  }

  ngOnInit() {

    this.dragService.waveFormElementRef = this.element;

    let url
    try {
      url = this.storyboard.attached_audio.media_waveform.url;
    }catch(e){}

    if (url){
      this.http.get(url)
        .toPromise()
        .then((res) => {
          this.reCreateWaveform(res.text());
        })
    }else {
      this.reCreateWaveform(null);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resizeWaveform();
  }

  protected reCreateWaveform(waveData = null){
    this.zone.runOutsideAngular(() => {
      let width = this.element.nativeElement.parentElement.offsetWidth;
      let height = this.element.nativeElement.parentElement.offsetHeight;
      let audioLength = 0;
      try {
        audioLength = this.storyboard.attached_audio.length;
      }catch(e){}

      this.waveformRenderer = new WaveformRenderer(
          width,
          height,
          waveData,
          this.timelineService.getPlayerControl(),
          this.timelineService,
          audioLength
      );

      this.waveformRenderer.setTimelinePositionGetter(() => {
        return this.timelineService.getTimelinePosition();
      })
      this.waveformRenderer.setTimelinePositionSetter((value) => {
        return this.timelineService.setTimelinePosition(value);
      })
    });

    this.element.nativeElement.append(this.waveformRenderer.app.view);
    this.resizeWaveform();
  }

  resizeWaveform() {
    this.waveformRenderer.setSize(
        this.element.nativeElement.parentElement.offsetWidth,
        this.element.nativeElement.parentElement.offsetHeight
    );

    this.waveformRenderer.setInnerWidth(
      this.timelineService.convertTimeToPx(this.storyboard.duration.as_milliseconds)
    );
  }

  ngOnDestroy(){
    if (this.waveformRenderer && this.waveformRenderer.app && this.waveformRenderer.app.destroy){
      this.waveformRenderer.app.destroy();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/audio-track/waveform/waveform.component.ts